<template>
  <section>
    <div class="container reset-password d-flex align-items-center">
      <div class="row">
        <div class="col-md-5 mx-auto">
          <p class="mb-4">
            Create a new password that is at least 8 characters long. We recommend using a mix of
            letters, numbers and special characters.
          </p>
          <form @submit.prevent="resetPassword()" class="reset">
            <div class="form-group m-label-left">
              <input
                v-model="password"
                type="password"
                minlength="8"
                class="form-control"
                id="new"
                required
              />
              <label for="new">New Password</label>
            </div>
            <div class="form-group m-label-left">
              <input
                v-model="confirmPassword"
                type="password"
                minlength="8"
                class="form-control"
                id="confirm"
                required
              />
              <label for="confirm">Confirm Password</label>
            </div>

            <div class="form-group">
              <div class="agreement">
                <div class="custom-control custom-checkbox">
                  <input
                    v-model="isAgree"
                    type="checkbox"
                    class="custom-control-input"
                    id="customCheck122"
                  />
                  <label class="custom-control-label" for="customCheck122"
                    >I agree to
                    <router-link
                      target="_blank"
                      style="text-decoration: none"
                      :to="{ name: 'employers' }"
                      >Jobshark's General Conditions for Employers</router-link
                    ></label
                  >
                </div>
              </div>
            </div>
            <button type="submit" class="btn btn-secondary mx-auto">
              Change Password
            </button>
          </form>
        </div>
      </div>
    </div>
    <CustomMainModal @close="showModal = false" v-show="showModal" :show="showModal">
      <template v-slot:header>
        <h5>{{ modalTitle }}</h5>
      </template>
      <Signin
        v-if="showLogin"
        @go-to-register="openModal"
        @go-to-reset-password="openModal"
      ></Signin>
      <Register
        v-if="showRegister"
        @go-to-login="openModal"
        @close="showModal = false"
        @emailVerification="(openEmailVerification = true), (showRegister = false)"
      ></Register>
      <ResetPassword v-if="showResetPassword" @close="showModal = false"></ResetPassword>
      <VerificationCode v-if="openEmailVerification" @prevStep="prevStep()"></VerificationCode>
    </CustomMainModal>
  </section>
</template>

<script>
import axios from 'axios';
import CustomMainModal from '../components/Modals/CustomMainModal';
import Signin from '@/components/Signin/Signin';
import Register from '@/components/Register/Register';
import ResetPassword from '@/components/ResetPassword/ResetPassword';
import VerificationCode from '@/components/SearchJob/VerificationCode';
import PublicNavigation from '../components/Navigations/PublicNavigation';
import Footer from '@/components/Navigations/PublicFooter';

export default {
  components: {
    CustomMainModal,
    Signin,
    Register,
    ResetPassword,
    VerificationCode,
    PublicNavigation,
    Footer,
  },
  data: () => ({
    isAgree: false,
    token: '',
    password: '',
    confirmPassword: '',
    email: '',
    modalTitle: '',
    showModal: false,
    showResetPassword: false,
    showLogin: false,
    showRegister: false,
    openEmailVerification: false,
  }),
  methods: {
    resetPassword() {
      if (!this.isAgree) {
        this.$toasted.error('Please accept our general conditions.', {
          theme: 'bubble',
          icon: 'fa-unlock-alt',
          position: 'bottom-right',
          duration: 5000,
        });
        return false;
      }
      axios(`${process.env.VUE_APP_API_URL}/auth/resetforgotpassword`, {
        method: 'post',
        data: {
          token: this.token,
          password: this.password,
          password_confirmation: this.confirmPassword,
          privacy: this.isAgree,
        },
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$toasted.success('Password changed successfully.', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
          this.$router.push('/');
        })
        .catch(() => {
          this.$toasted.error(
            'There was a problem with setting your new password, please try again',
            {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            },
          );
        });
    },
    openModal(e) {
      this.showModal = true;

      if (e.target.id == 'login-btn') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'register-btn') {
        this.modalTitle = 'Register';
        this.showLogin = false;
        this.showResetPassword = false;
        this.showRegister = true;
      } else if (e.target.id == 'register-link') {
        this.modalTitle = 'Register';
        this.showRegister = true;
        this.showLogin = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'forgotten-password') {
        this.modalTitle = 'Reset Password';
        this.showRegister = false;
        this.showLogin = false;
        this.showResetPassword = true;
      } else if (e.target.id == 'already-have-account') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      }
    },
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('token');
    this.token = myParam;
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';

.reset-password {
  min-height: 100vh;
  font-family: Lato, Roboto, 'Helvetica Neue', Arial, sans-serif;
  .row {
    flex: 1;

    .form-group {
      margin-bottom: 25px;
      .form-control {
        height: 48px;
        padding-left: 16px;
      }
    }
  }
}
</style>
